import { CustomPageConfigurationType, CustomPageType } from '../../../api/custom-pages.dao';
import { FormVmItemConfigType } from '../../../infrastructure/form-viewmodel-controller';
import { CustomPageFormViewModel } from '../../../components/_events/_manage-event/_edit-website/website-form-body/passport-pages/custom-pages/custom-page.viewmodel';
import { getPassportPageVmConfig } from '../config';
import { CustomPageEntity } from './custom-page.entity';


export class CustomPageMapper {
    static toEntity(props: CustomPageConfigurationType): CustomPageEntity {
        return CustomPageEntity.create(props);
    }

    static toDTO(entity: CustomPageEntity): CustomPageConfigurationType {
        return entity.toDTO();
    }

    static toVM(entity: CustomPageEntity, accountId: number, eventId: number, vmConfigOverrides?: FormVmItemConfigType[]): CustomPageFormViewModel {
        return CustomPageFormViewModel.create(entity.getId(), entity.getType(), entity.getProps(),
            getPassportPageVmConfig(vmConfigOverrides), accountId, eventId);
    }

    static vmToEntity(vm: CustomPageFormViewModel): CustomPageEntity {
        const props = { customPageId: vm.getId(), type: vm.getType() } as CustomPageConfigurationType;
        if (props.type === CustomPageType.EmbeddedHTML) {
            props.html = vm.getHTMLFileProps();
        }
        const vmProps = vm.getProps();
        if (Array.isArray((vmProps as { selectedMeetingIds?: string[] }).selectedMeetingIds)) {
            (vmProps as { selectedMeetingIds: string[] }).selectedMeetingIds =
                Array.from(new Set((vmProps as { selectedMeetingIds: string[] }).selectedMeetingIds));
        }
        return CustomPageMapper.toEntity({ ...vmProps, ...props });
    }
}
